import { lazy } from "react"

export const DashboardLayout = lazy(() => import("./Dashboard/DashboardLayout"));
export const CommonLayout = lazy(() => import("./CommonLayout/CommonLayout"));
// store
export * from "./Dashboard/store"